import React, {useState} from "react";
import { db } from "../firebase";
import {ref, set, update, push, child, } from 'firebase/database';
import Header from "../Components/Header/Header";
import { async } from "@firebase/util";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import auth from "../firebase";



export default Register =>{
    const [newAdmin, setNewAdmin] = useState({
        email: "",
        password: "",
        
      });


    const handleChange = (event) => {
        const { name, value } = event.target;
        setNewAdmin((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        createUserWithEmailAndPassword(auth, newAdmin.email, newAdmin.password)
        .then((userCredential) =>{
            const user = userCredential.user
            alert('user is registered')
            setNewAdmin({
                email:"",
                password: "",
            })
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            alert("error creating Admin: " , errorMessage);
            // ..
        });

        // console.log(newAdmin)
        // const adminId =await push(child(ref(db), 'admins')).key;
        // const adminData = {
        //     [adminId]: {
        //         name: newAdmin.name,
        //         email: newAdmin.email,
        //         password: newAdmin.password,
                
        //     },
        //   };

        // const newAdminRef = await ref(db, 'admins/');
        // await update(newAdminRef, adminData)
        // .then(()=>{
        //     alert('Admin is registered')
        //     // Clear the form
        //     setNewAdmin({
        //         name: '',
        //         email: '',
        //         password: '',
        //   });
          
        //   console.log('success: data is submitted')
        // })

    }
    return (
        <>
            <Header />
            <div class="w-1/3 max-w-md  bg-gray-800  border-gray-200 rounded-lg mx-auto mt-14  sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
                <form class="space-y-6" onSubmit={handleSubmit}>
                    <h5 class="text-xl font-medium text-white dark:text-white text-center">Register</h5>

                    {/* <div>
                        <label for="Name" class="block mb-2 text-sm font-medium text-white dark:text-white">Name</label>
                        <input type="text" name="name" id="name" value={newAdmin.name} onChange={handleChange} class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="Add Admin Name" required />
                    </div> */}
                    {/* <div>
                        <label for="Company code" class="block mb-2 text-sm font-medium text-white dark:text-white">Your email</label>
                        <input type="text" name="company code" id="code" class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="Add country code" required />
                    </div> */}

                    <div>
                        <label for="email" class="block mb-2 text-sm font-medium text-white dark:text-white">Your email</label>
                        <input type="email" name="email" id="email" value={newAdmin.email} onChange={handleChange} class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="Add company email" required />
                    </div>
                    <div>
                        <label for="password" class="block mb-2 text-sm font-medium text-white">Your password</label>
                        <input type="password" name="password" id="password" value={newAdmin.password} onChange={handleChange} placeholder="••••••••" class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required />
                    </div>
                
                    <button type="submit" class="w-full text-white bg-gray-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Register</button>
                    <div class="text-sm font-medium text-gray-500 dark:text-gray-300">
                        Already have an account? <a href="#" class="text-blue-700 hover:underline dark:text-blue-500">Sign in</a>
                    </div>
                </form>
            </div>
        </>
    )
}